import { eventBus, EVENTS } from '../commons/EventBus.js';
// const playingClass = 'is-playing';

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
  const template=data.template;
  if(template!='home'&&template!='homepage'&&template!=''){
    return;
  }
  initMap();
});

function initMap() {
  // const map = new google.maps.Map(document.getElementById("map"), {
  //   zoom: 13,
  //   center: { lat: 34.04924594193164, lng: -118.24104309082031 }
  // });
  // const trafficLayer = new google.maps.TrafficLayer();
  // trafficLayer.setMap(map);
}


$(document).on(  {

    click: function () {
        search_location();
    },

}, ".map-button");


function search_location(){
    var map_location = $("#map-search").val();
    if(map_location == ""){
        alert("Seleziona una città prima di proseguire");
        return;
    }
    $("#google-map").attr("src", "https://www.rds.it/traffic/" + map_location + "?zoom=12&viabilita_for_rds=true");
}


$(document).on(  {

    keypress: function (e) {
        if (e.keyCode == 13) {
            search_location();
        }
    },

}, "#map-search");





// $(document).on(  {
//
//     mouseenter: function () {
//
//         if(window.innerWidth >= 550){
//             $(this).addClass("selected");
//         }
//
//
//     },
//     mouseleave: function () {
//         if(window.innerWidth >= 550) {
//             $(this).removeClass("selected");
//         }
//     }
// }, ".container_rds_informa_single");
